(function documentContainerActionDefinition() {
    'use strict';
    angular.module('Actions')
        .service('documentContainerAction', [
             '$translate', 'documentContainerService', 'alerts', 'errorsExtend', '$q', 'authExtend',
             function documentContainerAction($translate, documentContainerService, alerts, errors, $q, authExtend) {
                 this.checkIn = function checkIn(container) {
                     var defered = $q.defer();
                     var promise = defered.promise;

                     $translate(['Warning', 'DocumentContainerCheckInConfirmText', 'Yes', 'No']).then(function (translated) {
                         return alerts.confirm(translated.Warning, translated.DocumentContainerCheckInConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                             if (!result) {
                                 return result;
                             }

                             return documentContainerService.chekIn(container).then(function getOk(result) {
                                 errors.showSuccess('DocumentContainerCheckInSucces');
                                 defered.resolve(result);
                             }, function (error) {
                                 errors.showError(error);
                                 defered.reject(error);
                             });
                         });
                     });
                     return promise;
                 };

                 this.checkInAll = function checkInAll(container) {
                     var defered = $q.defer();
                     var promise = defered.promise;

                     var checkInVersioned = authExtend.isInRole('DOCUMENTVERSIONED WRITE');
                     var accesCheckIn = authExtend.isInRole('DOCUMENT WRITE');

                     if (!accesCheckIn && !checkInVersioned) {
                         errors.showError('Forbidden');
                         defered.reject('Forbidden');
                         return promise;
                     }

                     $translate(['Warning', 'DocumentContainerCheckInAllConfirmText', 'CheckInAllCreateVersionConfirmText', 'Yes', 'No']).then(function (translated) {
                         return alerts.confirm(translated.Warning, translated.DocumentContainerCheckInAllConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                             if (!result) {
                                 defered.reject();
                                 return result;
                             }

                             if (checkInVersioned && accesCheckIn) {
                                 return alerts.confirm(translated.Warning, translated.CheckInAllCreateVersionConfirmText, translated.Yes, translated.No).then(function (createVersion) {
                                     return documentContainerService.checkInAll(createVersion, container).then(function (doc) {
                                         errors.showSuccess('DocumentContainerCheckInSucces');
                                         defered.resolve(doc);
                                     }, function (error) {
                                         errors.showError(error);
                                         defered.reject();
                                     });
                                 });
                             } else {
                                 return documentContainerService.checkInAll(checkInVersioned, container).then(function getOks(doc) {
                                     errors.showSuccess('DocumentContainerCheckInSucces');
                                     defered.resolve(doc);
                                 }, function (error) {
                                     errors.showError(error);
                                     defered.reject(error);
                                 });
                             }
                         });
                     });

                     return promise;
                 };

                 this.deleteContainer = function deleteDoc(docu) {
                     var defered = $q.defer();
                     var promise = defered.promise;

                     $translate(['Warning', 'DocumentContainerDeleteConfirmText', 'Yes', 'No']).then(function (translated) {
                         return alerts.confirm(translated.Warning, translated.DocumentContainerDeleteConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                             if (!result) {
                                 defered.reject();
                                 return result;
                             }
                             return documentContainerService.delete(docu).then(function getOks(doc) {
                                 errors.showSuccess('DocumentContainerDeleteSucces');
                                 defered.resolve(doc);

                             }, function (error) {
                                 errors.showError(error);
                                 defered.reject();
                             });
                         });
                     });

                     return promise;
                 }
             }
        ]);
})();
